module.exports = __webpack_public_path__ + "media/images/icons/icons_large/39_bride-a72a8457fe6c54e37ea32f18321e7f3a.png";